import React from "react";

import { Icon } from "shared/styles";
import { Spacer } from "shared/layout";

import { StyledPlaceholder, StyledPlaceholderProps } from "./styles";

interface PlaceholderProps extends StyledPlaceholderProps {
  label?: string;
  icon?: React.ComponentType<any>;
}

export const Placeholder: React.FC<PlaceholderProps> = ({ label, icon, ...rest }) => (
  <StyledPlaceholder aria-hidden {...rest}>
    <Spacer size="xs" align="center" justifyContent="center">
      {icon && <Icon as={icon} size="xxxl" />}
      <span>{label}</span>
    </Spacer>
  </StyledPlaceholder>
);
